import { SVGProps } from 'react';

export const Settings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 3V1C13 0.448 12.552 0 12 0H8C7.448 0 7 0.448 7 1V3H0V5H7V7C7 7.552 7.448 8 8 8H12C12.552 8 13 7.552 13 7V5H20V3H13Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 11C18 10.448 17.552 10 17 10H13C12.448 10 12 10.448 12 11V13H0V15H12V17C12 17.552 12.448 18 13 18H17C17.552 18 18 17.552 18 17V15H20V13H18V11Z"
      fill="currentColor"
    />
  </svg>
);
